import React from "react";
import { FieldRenderProps } from "react-final-form";

import Dropdown, { DropdownExternalProps } from "components/Input/Dropdown";

import withFieldControl from "../FieldControl";

type DictionaryItem = {
  value: any;
  label: string;
};

type Props = {
  title?: string;
  required?: boolean;
  name: string;
  onChangeCallback?: (
    newValue?: any | any[],
    previousValue?: any | any[],
  ) => void;
} & DropdownExternalProps;

class DropdownFieldControl extends React.Component<
  FieldRenderProps<any> & Props
> {
  onMultiChange = (items: DictionaryItem[] = []) => {
    const {
      input: { onChange, value: previousValue },
      onChangeCallback,
    } = this.props;

    const value = items.map(item => item.value);
    const event: any = { target: { value } };
    onChange(event);
    onChangeCallback?.(value, previousValue);
  };

  onChange = (item: DictionaryItem) => {
    const {
      input: { onChange, value: previousValue },
      onChangeCallback,
    } = this.props;

    const event: any = { target: { value: item?.value } };
    onChange(event);
    onChangeCallback?.(item.value, previousValue);
  };

  render() {
    const {
      action,
      title,
      required,
      input,
      meta,
      multi,
      validate,
      ...props
    } = this.props;
    return (
      <Dropdown
        input={input}
        onChange={multi ? this.onMultiChange : this.onChange}
        error={meta.touched && meta.error}
        multi={multi}
        required={required}
        {...props}
      />
    );
  }
}

export default withFieldControl(DropdownFieldControl);
